import { resetPasswordComponent } from './resetPassword.component';

export const resetPasswordStateName = 'app.resetPassword';

export const resetPasswordState = ($stateProvider) => {
  'ngInject';
  $stateProvider.state({
    name: resetPasswordStateName,
    url: '/resetPassword?token?user',
    component: resetPasswordComponent.name,
    resolve: {
      logout,
      v2: ($window, $location, envService, appConfig) => {
        'ngInject';
        const { ui } = appConfig;

        if (
          (ui.v2UI.oldBank || ui.v2UI.newBank) &&
          !envService.isProduction()
        ) {
          const params = $location.search();
          const query = Object.keys(params).length
            ? '?' +
              Object.entries(params)
                .map(([k, v]) => `${k}=${encodeURIComponent(v)}`)
                .join('&')
            : '';
          $window.location.href = '/v2/resetPassword' + query;
        }
        return true;
      },
    },
  });
};

function logout(userService) {
  'ngInject';
  userService.logout();
}
